import { messages } from './messages';
import { messages as overviewMessages } from '../overview/messages';

export const RESOURCE_ITEMS = [
  {
    title: messages.uploadProductsTitle,
    description: messages.uploadProductsDescription,
    buttonLabel: messages.importProductsButton,
    href: 'https://help.shipstation.com/hc/en-us/articles/360026158091-Add-Product-Records',
  },
  // {
  //   title: messages.selectLocationTitle,
  //   description: messages.selectLocationDescription,
  //   buttonLabel: messages.learnMoreFBSLocationsButton,
  //   href: '#',
  // },
  {
    title: messages.prepareProductsTitle,
    description: messages.prepareProductsDescription,
    buttonLabel: messages.reviewRequirementsButton,
    href: undefined,
  },
  {
    title: messages.sendInventoryTitle,
    description: messages.sendInventoryDescription,
    buttonLabel: messages.createAdvancedShippingNoticeButton,
    href: undefined,
  },
  // {
  //   title: messages.learnOrderRoutingTitle,
  //   description: messages.learnOrderRoutingDescription,
  //   buttonLabel: messages.learnMoreOrderRoutingButton,
  //   href: '#',
  // },
  {
    title: messages.scheduleReviewTitle,
    description: messages.scheduleReviewDescription,
    buttonLabel: messages.scheduleReviewButton,
    href: 'https://calendly.com/davis-saltzgiver/fulfilled-by-shipstation-first-onboarding-clone',
  },
];

export const PROCESS_STEPS = [
  {
    title: overviewMessages.processStep1Title,
    description: overviewMessages.processStep1Description,
  },
  {
    title: overviewMessages.processStep2Title,
    description: overviewMessages.processStep2Description,
  },
  {
    title: overviewMessages.processStep3Title,
    description: overviewMessages.processStep3Description,
  },
];
